import { css, SerializedStyles } from '@emotion/react';

export interface ImageStylesParams {
    fit: React.CSSProperties['objectFit'];
    radius: number | React.CSSProperties['borderRadius'];
    backgroundMask: React.CSSProperties['background'];
}

export const STATIC_STYLES: SerializedStyles = css`
    position: relative;
    overflow: hidden;
    border-radius: var(--image-radius);

    img {
        display: block;
        width: 100%;
        height: 100%;
        object-fit: var(--image-fit);
        position: relative;
    }

    [data-placeholder] {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--hc-color-neutral-tint-400);
        background-color: var(--hc-color-neutral-tint-200);
    }

    [data-mask] {
        position: absolute;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background: var(--image-mask);
    }
`;

export function useCssVariables(
    fit: React.CSSProperties['objectFit'],
    radius: number | React.CSSProperties['borderRadius'],
    backgroundMask: React.CSSProperties['background']
): React.CSSProperties {
    const radiusValue = typeof radius === 'number' ? `${radius}px` : radius || 0;

    return {
        '--image-mask': backgroundMask,
        '--image-fit': fit,
        '--image-radius': radiusValue,
    } as React.CSSProperties;
}
